import { PLANNING_COLUMN_COLORS } from '../config'

type TPlanningColumnType = keyof typeof PLANNING_COLUMN_COLORS.financial

export const getPlanningColumnColor = (columnType: TPlanningColumnType, isSob: boolean = false) =>
  PLANNING_COLUMN_COLORS[isSob ? 'sob' : 'financial'][columnType]

export const getPlanningPeriodColumnColor = (
  isPlanningByFY: boolean,
  isFuture: boolean,
  isSob: boolean = false
) => getPlanningColumnColor(isPlanningByFY && !isFuture ? 'year' : 'quarter', isSob)
